import { CountryProfileInfo, IResponseMessage } from "./CountriesProfile.type";
import { intialCountryProfileInfo } from "./CountriesProfileContext";
export const NAME_IS_REQUIRED = "Name is required";
export const COUNTRY_NAME_REQUIRED = "Country Name is required";
export const REGION_REQUIRED = "Region is required";
export const COUNTRY_CODE_REQUIRED = "Country Code is required";
export const CURRENCY_CODE_REQUIRED = "Currency Code is required";
export const LANGUAGE_CODE_REQUIRED = "Language Code is required";
export const COMPANY_CODE_REQUIRED = "Company Code is required";
export const STATE_REQUIRED = "State is required";
export const STREET_REQUIRED = "Street is required";
export const POSTALCODE_REQUIRED = "Zip/Postal code is required";
export const CITY_REQUIRED = "City is required";
export const PROVINCE_REQUIRED = "State/Province is required";
export const COUNTRY_REQUIRED = "Country is required";
export const VAT_ID_REQUIRED = "VAT ID is required";
export const REMITTANCE_DOCUMENT_REQUIRED = "Remittance document is required";
export const TERMS_AND_CONDITION_DOCUMENT_REQUIRED =
  "Terms and Conditions document is required";
export const BANK_NAME_REQUIRED = "Bank name is required";
export const CORRESPONDING_BANK_REQUIRED = "Corresponding bank required";
export const BANK_ADDRESS_REQUIRED = "Bank address required";
export const ADDRESS_REQUIRED = "Address required";
export const ACCOUNT_NAME_REQUIRED = "Account name is required";
export const ACCOUNT_NUMBER_REQUIRED = "Account number is required";
export const IBAN_NUMBER_REQUIRED = "IBAN number is required";
export const SWIFT_CODE_REQUIRED = "Swift code is required";
export const SWITCH_CODE_REQUIRED = "Switch code is required";
export const SWIFT_BIC_CODE_REQUIRED = "Swift/Bic code is required";
export const CORRESPONDING_BANK_SWIFT_OR_BIC_REQUIRED =
  "Corresponding bank swift or bic is required";
export const ACCOUNT_ADDRESS_REQUIRED = "Account address is required";
export const BANK_PHONE_REQUIRED = "Bank phone is required";
export const BC_CODE_REQUIRED = "BC code is required";
export const TAX_ID_REQUIRED = "Tax id is required";
export const BANK_KEY_REQUIRED = "Bank key is required";
export const SORT_CODE_REQUIRED = "Sort code is required";
export const ABN_IS_REQUIRED = "ABN is required";
export const BSB_CODE_REQUIRED = "BSB code is required";
export const InitialStateOfResponseMessage: IResponseMessage = {
  message: "",
  showMessage: false,
};
export const validateCountryProfileDetailsFields = (
  countryProfileInfo: CountryProfileInfo
) => {
  let countryProfileErrors = {
    ...intialCountryProfileInfo,
    termsAndConditions: [{ id: "", name: "", createdAt: "" }],
  };
  let isValidated = true;
  
  if (countryProfileInfo?.countryName.length < 1) {
    countryProfileErrors.countryName = COUNTRY_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.countryName = "";
  }
  if (countryProfileInfo?.countryCode.length < 1) {
    countryProfileErrors.countryCode = COUNTRY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.countryCode = "";
  }
  if (countryProfileInfo?.region.length < 1) {
    countryProfileErrors.region = REGION_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.region = "";
  }
  if (countryProfileInfo?.currencyCode.length < 1) {
    countryProfileErrors.currencyCode = CURRENCY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.currencyCode = "";
  }
  if (countryProfileInfo?.languageCode.length < 1) {
    countryProfileErrors.languageCode = LANGUAGE_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.languageCode = "";
  }
  if (
    countryProfileInfo?.companyCode=== null ||
    countryProfileInfo?.companyCode.length < 1
  ) {
    countryProfileErrors.companyCode = COMPANY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.companyCode = "";
  }
  
  if(  countryProfileInfo?.administrativeOriginName=== null || countryProfileInfo?.administrativeOriginName.length<1){
    countryProfileErrors.administrativeOriginName = NAME_IS_REQUIRED;
    isValidated = false;
  }
  else{
    countryProfileErrors.administrativeOriginName = "";
  }
  if (countryProfileInfo?.administrativeOriginCity.length < 1) {
    countryProfileErrors.administrativeOriginCity = CITY_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.administrativeOriginCity = "";
  }
  if (countryProfileInfo?.administrativeOriginCountry.length < 1) {
    countryProfileErrors.administrativeOriginCountry = COUNTRY_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.administrativeOriginCountry = "";
  }
  if (countryProfileInfo?.administrativeOriginStreet.length < 1) {
    countryProfileErrors.administrativeOriginStreet = STREET_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.administrativeOriginStreet = "";
  }
  if (countryProfileInfo?.administrativeOriginZipCode.length < 1) {
    countryProfileErrors.administrativeOriginZipCode = POSTALCODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.administrativeOriginZipCode = "";
  }
  switch (countryProfileInfo?.countryName.toLowerCase()) {
    case "ireland":
      return irelandRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "luxembourg":
      return irelandRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "portugal":
      return irelandRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "germany":
      return germanyRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "france":
      return germanyRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "sweden":
      return swedanRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "norway":
      return swedanRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "denmark":
      return swedanRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "switzerland":
      return switzerlandRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "belgium":
      return belgiumRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "austria":
      return belgiumRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "finland":
      return finlandRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "netherlands":
      return finlandRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "italy":
      return finlandRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "spain":
      return finlandRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "japan":
      return japanRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "new zealand":
      return newzealandRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "singapore":
      return singaporeRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
    case "australia":
      return australiaRemittanceDetailsValidation(
        countryProfileInfo,
        countryProfileErrors,
        isValidated
      );
  }
  return { isValidated, countryProfileErrors };
};
export const irelandRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.bankAddress) {
    countryProfileErrors.bankAddress = BANK_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankAddress = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.iban) {
    countryProfileErrors.iban = IBAN_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.iban = "";
  }
  if (!countryProfileInfo?.swiftCode) {
    countryProfileErrors.swiftCode = SWIFT_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftCode = "";
  }
  if (!countryProfileInfo?.vatId) {
    countryProfileErrors.vatId = VAT_ID_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.vatId = "";
  }
  if (!countryProfileInfo?.sortCode) {
    countryProfileErrors.sortCode = SORT_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.sortCode = "";
  }
  if (!countryProfileInfo?.correspondingBank) {
    countryProfileErrors.correspondingBank = CORRESPONDING_BANK_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.correspondingBank = "";
  }
  if (!countryProfileInfo?.correspondingBankSwiftBICCode) {
    countryProfileErrors.correspondingBankSwiftBICCode =
      CORRESPONDING_BANK_SWIFT_OR_BIC_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.correspondingBankSwiftBICCode = "";
  }
  return { isValidated, countryProfileErrors };
};
export const germanyRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.bankAddress) {
    countryProfileErrors.bankAddress = BANK_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankAddress = "";
  }
  if (!countryProfileInfo?.bankPhone) {
    countryProfileErrors.bankPhone = BANK_PHONE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankPhone = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountAddress) {
    countryProfileErrors.accountAddress = ACCOUNT_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountAddress = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.iban) {
    countryProfileErrors.iban = IBAN_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.iban = "";
  }
  if (!countryProfileInfo?.swiftCode) {
    countryProfileErrors.swiftCode = SWIFT_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftCode = "";
  }
  if (!countryProfileInfo?.vatId) {
    countryProfileErrors.vatId = VAT_ID_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.vatId = "";
  }
  if (!countryProfileInfo?.correspondingBankSwiftBICCode) {
    countryProfileErrors.correspondingBankSwiftBICCode =
      CORRESPONDING_BANK_SWIFT_OR_BIC_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.correspondingBankSwiftBICCode = "";
  }
  return { isValidated, countryProfileErrors };
};
export const swedanRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.bankAddress) {
    countryProfileErrors.bankAddress = BANK_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankAddress = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.iban) {
    countryProfileErrors.iban = IBAN_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.iban = "";
  }
  if (!countryProfileInfo?.swiftCode) {
    countryProfileErrors.swiftCode = SWIFT_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftCode = "";
  }
  if (!countryProfileInfo?.vatId) {
    countryProfileErrors.vatId = VAT_ID_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.vatId = "";
  }
  if (!countryProfileInfo?.currencyCode) {
    countryProfileErrors.currencyCode = CURRENCY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.currencyCode = "";
  }
  if (!countryProfileInfo?.companyCode) {
    countryProfileErrors.companyCode = COMPANY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.companyCode = "";
  }
  return { isValidated, countryProfileErrors };
};
export const switzerlandRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.bankAddress) {
    countryProfileErrors.bankAddress = BANK_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankAddress = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.iban) {
    countryProfileErrors.iban = IBAN_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.iban = "";
  }
  if (!countryProfileInfo?.swiftCode) {
    countryProfileErrors.swiftCode = SWIFT_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftCode = "";
  }
  if (!countryProfileInfo?.vatId) {
    countryProfileErrors.vatId = VAT_ID_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.vatId = "";
  }
  if (!countryProfileInfo?.bcCode) {
    countryProfileErrors.bcCode = BC_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bcCode = "";
  }
  if (!countryProfileInfo?.currencyCode) {
    countryProfileErrors.currencyCode = CURRENCY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.currencyCode = "";
  }
  if (!countryProfileInfo?.companyCode) {
    countryProfileErrors.companyCode = COMPANY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.companyCode = "";
  }
  return { isValidated, countryProfileErrors };
};
export const belgiumRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.bankAddress) {
    countryProfileErrors.bankAddress = BANK_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankAddress = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.iban) {
    countryProfileErrors.iban = IBAN_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.iban = "";
  }
  if (!countryProfileInfo?.swiftCode) {
    countryProfileErrors.swiftCode = SWIFT_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftCode = "";
  }
  if (!countryProfileInfo?.vatId) {
    countryProfileErrors.vatId = VAT_ID_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.vatId = "";
  }
  if (!countryProfileInfo?.correspondingBank) {
    countryProfileErrors.correspondingBank = CORRESPONDING_BANK_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.correspondingBank = "";
  }
  if (!countryProfileInfo?.companyCode) {
    countryProfileErrors.companyCode = COMPANY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.companyCode = "";
  }
  return { isValidated, countryProfileErrors };
};
export const finlandRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.bankAddress) {
    countryProfileErrors.bankAddress = BANK_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankAddress = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.iban) {
    countryProfileErrors.iban = IBAN_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.iban = "";
  }
  if (!countryProfileInfo?.swiftCode) {
    countryProfileErrors.swiftCode = SWIFT_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftCode = "";
  }
  if (!countryProfileInfo?.vatId) {
    countryProfileErrors.vatId = VAT_ID_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.vatId = "";
  }
  if (!countryProfileInfo?.correspondingBank) {
    countryProfileErrors.correspondingBank = CORRESPONDING_BANK_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.correspondingBank = "";
  }
  if (!countryProfileInfo?.currencyCode) {
    countryProfileErrors.currencyCode = CURRENCY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.currencyCode = "";
  }
  if (!countryProfileInfo?.companyCode) {
    countryProfileErrors.companyCode = COMPANY_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.companyCode = "";
  }
  return { isValidated, countryProfileErrors };
};
export const japanRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.addressLine1) {
    countryProfileErrors.addressLine1 = ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.addressLine1 = "";
  }
  if (!countryProfileInfo?.addressLine2) {
    countryProfileErrors.addressLine2 = ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.addressLine2 = "";
  }
  if (!countryProfileInfo?.addressLine3) {
    countryProfileErrors.addressLine3 = ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.addressLine3 = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.swiftBicCode) {
    countryProfileErrors.swiftBicCode = SWIFT_BIC_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftBicCode = "";
  }
  return { isValidated, countryProfileErrors };
};
export const newzealandRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.bankAddress) {
    countryProfileErrors.bankAddress = BANK_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankAddress = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.swiftCode) {
    countryProfileErrors.swiftCode = SWIFT_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftCode = "";
  }
  return { isValidated, countryProfileErrors };
};
export const singaporeRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.bankAddress) {
    countryProfileErrors.bankAddress = BANK_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankAddress = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.switchCode) {
    countryProfileErrors.switchCode = SWITCH_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftCode = "";
  }
  if (!countryProfileInfo?.bankKey) {
    countryProfileErrors.bankKey = BANK_KEY_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankKey = "";
  }
  return { isValidated, countryProfileErrors };
};
export const australiaRemittanceDetailsValidation = (
  countryProfileInfo: CountryProfileInfo,
  countryProfileErrors: CountryProfileInfo,
  isValidated: boolean
) => {
  if (!countryProfileInfo?.bankName) {
    countryProfileErrors.bankName = BANK_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankName = "";
  }
  if (!countryProfileInfo?.bankAddress) {
    countryProfileErrors.bankAddress = BANK_ADDRESS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bankAddress = "";
  }
  if (!countryProfileInfo?.accountName) {
    countryProfileErrors.accountName = ACCOUNT_NAME_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountName = "";
  }
  if (!countryProfileInfo?.accountNumber) {
    countryProfileErrors.accountNumber = ACCOUNT_NUMBER_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.accountNumber = "";
  }
  if (!countryProfileInfo?.swiftCode) {
    countryProfileErrors.swiftCode = SWIFT_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.swiftCode = "";
  }
  if (!countryProfileInfo?.abn) {
    countryProfileErrors.abn = ABN_IS_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.abn = "";
  }
  if (!countryProfileInfo?.bsbCode) {
    countryProfileErrors.bsbCode = BSB_CODE_REQUIRED;
    isValidated = false;
  } else {
    countryProfileErrors.bsbCode = "";
  }
  return { isValidated, countryProfileErrors };
};
